import { graphic } from 'echarts'

// 格式化数字
const formatNumber = (num) => {
  return Number(num || 0).toFixed(0)
}

export default (categories, data) => {
  const maxItems = 20
  const displayCategories = Array.isArray(categories) ? categories.slice(0, maxItems) : []
  const displayData = Array.isArray(data) ? data.slice(0, maxItems) : []

  return {
    grid: {
      top: 0,
      bottom: 40,
      left: 140,
      right: 80
    },
    xAxis: {
      type: 'value',
      min: 0,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)'
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(106, 114, 124, 0.1)',
          type: 'dashed'
        }
      },
      name: '告警数',
      nameTextStyle: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)'
      }
    },
    yAxis: {
      type: 'category',
      inverse: true,
      data: displayCategories,
      axisLabel: {
        fontSize: 12,
        fontFamily: 'HarmonyOS Sans SC',
        fontWeight: 300,
        color: 'rgba(46, 46, 46, 0.70)',
        interval: 0,
      },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.90)',
      borderColor: 'transparent',
      borderRadius: 16,
      extraCssText: 'backdrop-filter: blur(4px); box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);',
      textStyle: {
        color: '#2E2E2E',
        fontFamily: "HarmonyOS Sans SC",
        fontSize: 14
      },
      axisPointer: {
        type: 'shadow'
      },
      formatter: (params) => {
        if (params && params.length > 0) {
          const param = params[0]
          return `<div style="color: rgba(46, 46, 46, 0.70); font-family: 'HarmonyOS Sans SC'; font-size: 12px; margin-bottom: 4px;">${param.name}</div>
                     <div style="display: flex; align-items: center; gap: 4px; color: #2E2E2E; font-family: 'HarmonyOS Sans SC'; font-size: 14px;">
                      <span style="display:inline-block;margin-right:4px;border-radius:10px;width:6px;height:6px;background-color:#FF7A45;"></span>
                      告警数: ${formatNumber(param.value)} 次</div>`
        }
        return ''
      }
    },
    series: [{
      type: 'bar',
      data: displayData,
      barWidth: 14,
      itemStyle: {
        borderRadius: [0, 6, 6, 0],
        color: graphic.LinearGradient(0, 0, 1, 0, [
          { offset: 0, color: '#FF7A45' },
          { offset: 1, color: 'rgba(255, 122, 69, 0.3)' }
        ])
      },
      label: {
        show: true,
        position: 'right',
        color: 'rgba(46,46,46,0.7)',
        fontFamily: 'HarmonyOS Sans SC'
      }
    }]
  }
}

